const configProviderContextKey = Symbol();

export { configProviderContextKey };
//# sourceMappingURL=config-provider.mjs.map
